import { render, staticRenderFns } from "./ImportModal.vue?vue&type=template&id=bf11cc10"
import script from "./ImportModal.vue?vue&type=script&lang=js"
export * from "./ImportModal.vue?vue&type=script&lang=js"
import style0 from "./ImportModal.vue?vue&type=style&index=0&id=bf11cc10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports